import React from 'react'
import ReactDOM from 'react-dom'
import { withSuspenseWrapper } from '../components/SuspenseWrapper'

const WrapperApp = withSuspenseWrapper(React.lazy(() => import('./app')))

document.addEventListener('DOMContentLoaded', () => {
    if (location?.pathname?.includes('/app/kpi_drilling')) {
        ReactDOM.render(<WrapperApp />, document.getElementById('main-content'))
    }
})
